import { gql } from '@apollo/client';

import { OutcomesFragment } from 'approot/shared/graphql/outcomes/outcomes.graphql';
import { LessonMaterialFragment } from 'approot/shared/lesson-materials/lesson-material-fragment';

export const teachingAndLearningSequenceFragment = gql`
  fragment TeachingLearningSequence on ActivitiesTeachingLearningSequenceItem {
    id
    category
    data
    component {
      id
      properties {
        activitySettings {
          differentiation
          duration
          checkPoint
          furtherEnrichment
        }
      }
      sectionId
    }
    lessonMaterials {
      ...LessonMaterialFragment
    }
    theEsDetails {
      id
      name
      link
    }
    visibleThinkingActivitiesDetails {
      id
      name
      link
    }
    highImpactTeachingStrategiesDetails {
      id
      name
      link
    }
    sectionId
    sort
    type
    connections {
      subject
      outcomes {
        ...OutcomesFragment
        description
        type
      }
    }
  }
  ${OutcomesFragment}
  ${LessonMaterialFragment}
`;

export const GET_LESSON_TEACHING_LEARNING_SEQUENCE = gql`
  query GetLessonTeachingAndLearningSequence(
    $input: GetTeachingAndLearningSequenceInput!
  ) {
    getLessonTeachingAndLearningSequence(input: $input) {
      ...TeachingLearningSequence
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const UPDATE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation UpdateInteractiveTeachingLearningSequenceItem(
    $input: UpdateTeachingLearningSequenceItemInput!
  ) {
    updateTeachingLearningSequenceItem(input: $input) {
      ...TeachingLearningSequence
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const INSERT_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation InsertTeachingLearningSequenceItem(
    $input: InsertTeachingLearningSequenceItemInput!
  ) {
    insertTeachingLearningSequenceItem(input: $input) {
      ...TeachingLearningSequence
    }
  }
  ${teachingAndLearningSequenceFragment}
`;

export const DELETE_TEACHING_LEARNING_SEQUENCE_ITEM = gql`
  mutation DeleteTeachingLearningSequenceItem(
    $input: DeleteTeachingLearningSequenceItemInput!
  ) {
    deleteTeachingLearningSequenceItem(input: $input)
  }
`;

export const GET_ALL_DEFINED_TEACHING_AND_LEARNING_STRATEGIES = gql`
  query GetAllDefinedTeachingAndLearningStrategies {
    getAllDefinedTeachingAndLearningStrategies {
      theEs {
        id
        name
        link
      }
      visibleThinkingActivities {
        id
        name
        link
      }
      highImpactTeachingStrategies {
        id
        name
        link
      }
    }
  }
`;
